const irregularInflections: Record<string, string> = { person: 'people', reply: 'replies' }

export function pluralize(count: number, singularWord: string, includeCount = true) {
  const plural = count !== 1
  const pluralWord = irregularInflections[singularWord] || `${singularWord}s`

  return [
    includeCount ? `${count.toLocaleString()} ` : '',
    plural ? pluralWord : singularWord,
  ].join('')
}
